import { descendentsOfNode } from 'js/utils/org-utils';

export const nodeSorter = (a, b) => {
  const aName = `${a.type === 'org' ? 1 : 2}_${a.name.toUpperCase()}`;
  const bName = `${b.type === 'org' ? 1 : 2}_${b.name.toUpperCase()}`;
  return aName.localeCompare(bName);
};

export function sortChildren(children) {
  return [...children].sort(nodeSorter);
}

export function isDescendantOf(ancestorNode, nodeId) {
  return descendentsOfNode(ancestorNode).some((n) => n.id === nodeId);
}

/** Drop target `canDrop` for an org folder (org-node surface, including its open subtree). */
export function canDropSourceOnOrgFolder(source, folderNode, uniqueContextId) {
  if (source.data.uniqueContextId !== uniqueContextId) {
    return false;
  }
  if (source.data.type === 'team') {
    return true;
  }
  if (source.data.type === 'org-node') {
    const dragged = source.data.node;
    return (
      dragged.id !== folderNode.id && !isDescendantOf(dragged, folderNode.id)
    );
  }
  return false;
}

/** Block drags that begin on buttons, links, fields, or dropdown menus in the row. */
export function canStartDragFromOrgTreeRow({ input, element }) {
  const target = document.elementFromPoint(input.clientX, input.clientY);
  if (!target || !element.contains(target)) {
    return false;
  }
  if (
    target.closest(
      'button, a, input, textarea, select, [role="button"], [role="menuitem"], .dropdown-menu'
    )
  ) {
    return false;
  }
  return true;
}

export function orgRowDropHighlightKey(depthId) {
  return `org-row:${depthId}`;
}
